export default "__VITE_ASSET__j9AeOD0O__"